import { ADMIN_ROLES } from '@/auth/roles';
import { RequireRole } from '@/auth/RequireRole';
import type { RouteObject } from 'react-router-dom';

/**
 * Payments area. OWNED BY `m4m5-money` (M5); see docs/BUILD-ORCHESTRATION.md.
 *
 *   /payments         summary cards + payment history (filters in the URL)
 *   /payments/queue   the verification queue (?id= opens one proof)
 *
 * `ClientPaymentsPanel.tsx` (default export, props { clientId }) is the client
 * profile's Membership tab; the clients area renders it.
 */
export const paymentsRoutes: RouteObject[] = [
  {
    path: 'payments',
    handle: { crumb: 'Payments' },
    // Owner and admin only: a trainer never sees this area (CLAUDE.md "Roles").
    element: <RequireRole roles={ADMIN_ROLES} />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./PaymentsPage')).PaymentsPage }) },
      {
        path: 'queue',
        handle: { crumb: 'Proofs to check' },
        lazy: async () => ({ Component: (await import('./PaymentQueuePage')).PaymentQueuePage }),
      },
    ],
  },
];
